import { Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-candidate-pdf-resume-card',
  templateUrl: './candidate-pdf-resume-card.component.html',
  styleUrls: ['./candidate-pdf-resume-card.component.scss'],
})
export class CandidatePdfResumeCardComponent {
  @Input() resumeSrc: string;
  @Input() resumeId: number;
  @Input() resumeTitleHidden: boolean;
  @Input() showCard = true;
}
